import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  postUrl() {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_RESTAURANTS)
  },

  method() {
    return 'POST'
  },

  /**
   * @param {any} payload 
   */
  format(payload) {
    return payload
  },

  /**
   * @param {any} raw 
   */
  parse(raw) {
    if (!raw?.success) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Erreur lors de la création du restaurant',
        data: raw?.data || null,
      }
    }

    return {
      statusCode: 200,
      message: 'ok',
      data: raw.data
    }
  },
}
